<template>
  <li
    :key="hit.objectID"
    v-bind="rootProps"
    class=""
    @click="onClick"
    @auxclick="onAuxClick"
  >
    <slot
      v-if="$slots['item']"
      name="item"
      :item="hit"
      :index="index"
      :insights="insights"
      :send-event="sendEvent"
    />
    <slot name="banner" />

    <slot />
  </li>

  <!-- <div
    :hits="state.items"
    :itemComponent="itemComponent"
    :banner="showBanner ? state.banner : undefined"
    :bannerComponent="$slots['banner']"
    :sendEvent="state.sendEvent"
    :classNames="classNames && {
      root: 'ais-Hits',
      list: 'ais-Hits-list',
      item: 'ais-Hits-item',
      bannerRoot: 'ais-Hits-banner',
      bannerImage: 'ais-Hits-banner-image',
      bannerLink: 'ais-Hits-banner-link'
    }"
  >
  </div> -->
</template>

<script setup>

const props = defineProps({
  hit: { type: Object, default: null },
  index: { type: Number, default: null },
  insights: { type: Number, default: null },
  sendEvent: { type: Function, default: null },
  onClick: { type: Function, default: null },
  onAuxClick: { type: Function, default: null }
})

</script>
